import {useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import {AuthRedirectParents, PostJSON, ServerImage} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {BreadCrumbs} from "../../../components/open/pages";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {ThinWarningIcon, TomansIcon} from "../../../components/icons/material-icons";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {GregorianToPersian} from "../../../components/techaran/date-convert";

export const StudentsCenterClassViewScreen = () => {
    const {classNd} = useParams();
    const [data,setData] = useState({
        loaded:false,
        title:'',
        desc:'',
        img:'',
        maxParticipants:0,
        teacher:'',
        price:0,
        isWorkshop:false,
        hasExpiration:false,
        expiresAt:'2000-01-01 00:00:00',
        pendingCount:0,
        activeCount:0,
        isPending:false,
        isActive:false,
        pendingCreatedAt:'2000-01-01 00:00:00',
        approvedAt:'2000-01-01 00:00:00',
        activePrice:0,
        isExpired:false,
        sessionCount:0,
        presentedAt:'2000-01-01 00:00:00',
        payND:'',
        isPaid:false,
    });
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/parents/center/get-class',
            {nd:classNd},
            true,
            (d: {
                result:string,
                reason:string|undefined,
                title:string,
                desc:string,
                img:string,
                maxParticipants:number,
                teacher:string,
                price:number,
                isWorkshop:0|1,
                hasExpiration:0|1,
                expiresAt:string,
                pendingCount:number,
                activeCount:number,
                isPending:boolean,
                isActive:boolean,
                pendingCreatedAt:string,
                approvedAt:string,
                activePrice:number,
                isExpired:boolean,
                sessionCount:number,
                presentedAt:string,
                payND:string,
                isPaid:0|1,
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                document.title = `${d.title} | کلاس فوق برنامه | نهال`;
                setData({
                    loaded:true,
                    title:d.title,
                    desc:d.desc,
                    img:d.img,
                    maxParticipants:d.maxParticipants,
                    teacher:d.teacher,
                    price:d.price,
                    isWorkshop:d.isWorkshop === 1,
                    hasExpiration:d.hasExpiration === 1,
                    expiresAt:d.expiresAt,
                    pendingCount:d.pendingCount,
                    activeCount:d.activeCount,
                    isPending:d.isPending,
                    isActive:d.isActive,
                    pendingCreatedAt:d.pendingCreatedAt,
                    approvedAt:d.approvedAt,
                    activePrice:d.activePrice,
                    isExpired: d.isExpired,
                    presentedAt: d.presentedAt,
                    sessionCount: d.sessionCount,
                    isPaid: d.isPaid === 1,
                    payND: d.payND,
                });
            },
            ()=>{},
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    useEffect(() => {
        fetchData();
    }, []);
    const requestSignup = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/parents/center/class/request',
            {nd:classNd},
            true,
            (d: {
                result:string,
                reason:undefined|'login'|'full'|'expired'|'not-found',
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectParents();
                    else if(d.reason === 'full') {
                        fetchData();
                        ShowSnackbar('ظرفیت این کلاس تکمیل است.', 'باشه', 5000);
                    } else if(d.reason === 'expired'){
                        fetchData();
                        ShowSnackbar('زمان ثبت‌نام این کلاس به اتمام رسیده است.','باشه',5000);
                    } else if(d.reason === 'not-found'){
                        ShowSnackbar('کلاس یافت نشد.','باشه',5000);
                    }
                    return;
                }
                ShowProgressLoading();
                fetchData();
                ShowSnackbar(
                    'پیش ثبت‌نام شما برای این کلاس انجام شد.',
                    'باشه',
                    5000,
                );
            },
            ()=>{},
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    const navigate = useNavigate();
    const issuePayment = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/parents/center/class/pay',
            {
                nd:classNd as string,
            },
            true,
            (d: {
                result:string,
                reason:string,
                nd:string,
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectParents();
                    return;
                }
                navigate(`/students/center/invoice/${d.nd}`);
                ShowSnackbar(
                    'لطفا فاکتور ایجاد شده را پرداخت نمایید.',
                    'باشه',
                    5000,
                );
            },
            ()=>{},
            AuthRedirectParents,
            'parents',
        ).then(void 0);
    };
    return (
        <>
            <BreadCrumbs links={[
                {title: 'پنل دانش‌آموزان', url: '/students/'},
                {title: 'کلاس فوق برنامه', url: '/students/center'},
                {title: data.title, url: `/students/center/class/${classNd}`},
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="row justify-content-center">
                            <div className="col-lg-7">
                                <div className="sci-class-view">
                                    <em style={{backgroundImage: `url(${ServerImage(data.img, 500)})`}}/>
                                    <b>{data.title}</b>
                                    <i>مربی: {data.teacher}</i>
                                    <p>{data.desc}</p>
                                    <div className="sci-class-view-feature">
                                        <span>وضعیت: </span>
                                        <b>{data.isActive ? 'ثبت‌نام شده قطعی' : (data.isPending ? 'در انتظار تایید ثبت‌نام' : 'ثبت‌نام نشده')}</b>
                                    </div>
                                    {
                                        data.isActive ?
                                            <div className="sci-class-view-feature">
                                                <span>وضعیت پرداخت: </span>
                                                <b>{data.isPaid ? 'پرداخت شده' : 'در انتظار پرداخت'}</b>
                                            </div> : null
                                    }
                                    {
                                        data.isPaid ?
                                            <div className="sci-class-view-feature">
                                                <span>فاکتور پرداخت: </span>
                                                <b>
                                                    <Link to={`/students/center/invoice/${data.payND}`} style={{color:'#0a53be'}}>
                                                        مشاهده فاکتور
                                                    </Link>
                                                </b>
                                            </div> : null
                                    }
                                    <div className="sci-class-view-feature">
                                        <span>قیمت: </span>
                                        <b>{CurrencyFormat(data.isActive ? data.activePrice : data.price)}<TomansIcon/></b>
                                    </div>
                                    {
                                        data.isWorkshop ?
                                            <div className="sci-class-view-feature">
                                                <span>زمان برگزاری: </span>
                                                <b>{StringDigitsConvertToPersian(`${data.presentedAt.split(' ')[1].split(':')[0]}:${data.presentedAt.split(' ')[1].split(':')[1]}` + " " + GregorianToPersian(data.presentedAt.split(' ')[0]).replaceAll('-', '/'))}</b>
                                            </div> :
                                            <div className="sci-class-view-feature">
                                                <span>تعداد جلسات: </span>
                                                <b>{CurrencyFormat(data.sessionCount)} جلسه</b>
                                            </div>
                                    }
                                    {
                                        (data.activeCount + data.pendingCount) >= data.maxParticipants ?
                                            <div className="alert alert-danger">
                                                <ThinWarningIcon/>
                                                ظرفیت این کلاس تکمیل شده است.
                                            </div> : null
                                    }
                                    {
                                        data.isExpired && !data.isActive && !data.isPending ?
                                            <div className="alert alert-danger">
                                                <ThinWarningIcon/>
                                                مهلت ثبت‌نام برای این کلاس به اتمام رسیده است.
                                            </div> : null
                                    }
                                    {
                                        data.isActive && !data.isPaid ?
                                            <div className="d-flex justify-content-end align-items-center"
                                                 style={{padding: '20px 20px 0 20px'}}>
                                                <button className="btn-pay" onClick={issuePayment}>
                                                    <b>پرداخت هزینه کلاس</b>
                                                </button>
                                            </div> : null
                                    }
                                    {
                                        data.isPending || data.isActive || data.isExpired ||
                                        ((data.activeCount + data.pendingCount) >= data.maxParticipants) ?
                                            null :
                                            <div className="d-flex justify-content-end align-items-center"
                                                 style={{padding: '20px 20px 0 20px'}}>
                                                <button className="btn-pay" onClick={requestSignup}>
                                                    <b>درخواست ثبت‌نام</b>
                                                </button>
                                            </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div> : null
            }
        </>
    );
};